import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import {
  ExpenseCategoryLabelsMatchParams,
  expenseCategoryLabelsRouteProps,
} from 'src/navigation/routeProps'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'

export const selectOrgIdFromRoute = createSelector(
  [selectCalculatedBackgroundLocation],
  (backgroundLocation) => {
    const mtch = matchPath<ExpenseCategoryLabelsMatchParams>(
      backgroundLocation.pathname,
      expenseCategoryLabelsRouteProps,
    ) as match<ExpenseCategoryLabelsMatchParams>
    return mtch?.params.orgId
  },
)

export const selectExpenseCategoryIdFromRoute = createSelector(
  [selectCalculatedBackgroundLocation],
  (backgroundLocation) => {
    const mtch = matchPath<ExpenseCategoryLabelsMatchParams>(
      backgroundLocation.pathname,
      expenseCategoryLabelsRouteProps,
    ) as match<ExpenseCategoryLabelsMatchParams>
    return mtch?.params.expenseCategoryId
  },
)
